__turbopack_context__.v({
  "appointment": "ReservationSummary-module__fb5SMq__appointment",
  "avatar": "ReservationSummary-module__fb5SMq__avatar",
  "card": "ReservationSummary-module__fb5SMq__card",
  "change": "ReservationSummary-module__fb5SMq__change",
  "empty": "ReservationSummary-module__fb5SMq__empty",
  "initials": "ReservationSummary-module__fb5SMq__initials",
  "label": "ReservationSummary-module__fb5SMq__label",
  "person": "ReservationSummary-module__fb5SMq__person",
  "portal": "ReservationSummary-module__fb5SMq__portal",
  "resource": "ReservationSummary-module__fb5SMq__resource",
  "resourceCopy": "ReservationSummary-module__fb5SMq__resourceCopy",
  "resourceHeading": "ReservationSummary-module__fb5SMq__resourceHeading",
  "resourceIdentity": "ReservationSummary-module__fb5SMq__resourceIdentity",
  "service": "ReservationSummary-module__fb5SMq__service",
  "summary": "ReservationSummary-module__fb5SMq__summary",
  "total": "ReservationSummary-module__fb5SMq__total",
});
